var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{staticClass:"p-2",attrs:{"bg-variant":"white"}},[_c('strong',{staticClass:"smart-quotes pr-2"},[_vm._v("“")]),_c('em',[_vm._t("default")],2),_c('strong',{staticClass:"smart-quotes pl-2"},[_vm._v("”")])])
}
var staticRenderFns = []

export { render, staticRenderFns }